import { Check } from 'lucide-react';

import { UnknownValue } from './UnknownValue';

/** Whether BonsaiBar follows the venue on Instagram: yes, no, or unknown. */
export function FollowingPill({ value }: { value: boolean | null }) {
  if (value === null) return <UnknownValue />;
  if (!value) {
    return (
      <span className="nb-pill" style={{ height: 20, fontSize: 10.5, color: 'var(--nb-muted)' }}>
        Not following
      </span>
    );
  }
  return (
    <span className="nb-pill nb-status-ontrack" style={{ height: 20, fontSize: 10.5 }}>
      <Check size={11} aria-hidden="true" />
      We follow them
    </span>
  );
}
